import moment from "moment";

interface PayFrequencyOption {
  value?: string;
  label?: string;
}

const DATE_FORMATS = ["MM/DD/YYYY", "M/D/YYYY", "YYYY-MM-DD"];

const normalizePayFrequencyValue = (value?: string) =>
  value ? value.trim().toLowerCase().replace(/[\s_-]/g, "") : "";

const parseDate = (date: string) => {
  const parsed = moment(date, DATE_FORMATS, true);
  return parsed.isValid() ? parsed : null;
};

export const inferPayPeriodStartDate = (
  payFrequency: PayFrequencyOption,
  endDate: string
): Date | undefined => {
  const parsedEndDate = parseDate(endDate);

  if (!parsedEndDate) {
    return undefined;
  }

  switch (normalizePayFrequencyValue(payFrequency?.value)) {
    case "weekly":
      return parsedEndDate.subtract(6, "days").toDate();
    case "biweekly":
      return parsedEndDate.subtract(13, "days").toDate();
    case "monthly":
      return parsedEndDate.subtract(parsedEndDate.daysInMonth() - 1, "days").toDate();
    case "quarterly":
      return parsedEndDate.subtract(3, "months").add(1, "day").toDate();
    case "semimonthly":
    case "bimonthly":
      return parsedEndDate.subtract(15, "days").toDate();
    case "annual":
    case "yearly":
      return parsedEndDate.subtract(364, "days").toDate();
    case "onetime":
      return parsedEndDate.toDate();
    default:
      return undefined;
  }
};

export const inferPayPeriodEndDate = (
  payFrequency: PayFrequencyOption,
  startDate: string
): Date | undefined => {
  const parsedStartDate = parseDate(startDate);

  if (!parsedStartDate) {
    return undefined;
  }

  switch (normalizePayFrequencyValue(payFrequency?.value)) {
    case "weekly":
      return parsedStartDate.add(6, "days").toDate();
    case "biweekly":
      return parsedStartDate.add(13, "days").toDate();
    case "monthly":
      return parsedStartDate.add(parsedStartDate.daysInMonth() - 1, "days").toDate();
    case "quarterly":
      return parsedStartDate.add(3, "months").subtract(1, "day").toDate();
    case "semimonthly":
    case "bimonthly":
      return parsedStartDate.add(15, "days").toDate();
    case "annual":
    case "yearly":
      return parsedStartDate.add(364, "days").toDate();
    case "onetime":
      return parsedStartDate.toDate();
    default:
      return undefined;
  }
};
